module.exports = __webpack_public_path__ + "img/shuibeng2.40473341.png";